export default "__VITE_ASSET__Pn36DiAI__"